import React, { Component } from 'react'
import { Accordion, Icon } from 'semantic-ui-react'

class Survey extends Component {
    state = { activeIndex: 0 }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    renderQuestion = (item, index) => {
        const { activeIndex } = this.state
        const { question, value } = item
        let answer
        if (typeof (value) === 'string') {
            answer = value
        } else {
            answer = value.optionText
        }
        return (
            <div key={index}>
                <Accordion.Title
                    active={activeIndex === index}
                    index={index}
                    onClick={this.handleClick}
                >
                    <Icon name='dropdown' />
                    {question}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index}>
                    <p>
                        {answer}
                    </p>
                </Accordion.Content>
            </div>
        )

    }

    render() {
        const { survey } = this.props
        return (
            <Accordion fluid styled>
                {survey.map((question, index) => {
                    return this.renderQuestion(question, index)
                })}
            </Accordion>
        )
    }
}

export default Survey